module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Rankings","heading":"Rankings","tab_weekly":"Weekly","tab_monthly":"Monthly","tab_yearly":"Yearly","tab_actress":"Girls"},"ja":{"browser_title":"ランキング","heading":"人気ランキング","tab_weekly":"週間ランキング","tab_monthly":"月間ランキング","tab_yearly":"年間ランキング","tab_actress":"出演者ランキング"}}')
  delete Component.options._Ctor
}
